export const language_ch = {
    Feedback: {
        main_title: "请完善您的反馈信息",
        sub_title: "我们将会做得更好",
        boarding: "实测是否可搭载",
        yes: "是",
        no: "否",
        no_test: "未测试",
        camera_name: "相机型号",
        lens_name: "镜头型号",
        feedback: "问题描述或建议",
        feedback_describe: "详述您的操作步骤和现象更有助于我们快速解",
        contact: "联系方式",
        phone_or_email: "手机号码/邮箱",
        feedback_way: "您也可以通过以下方式反馈",
        by_phone: "电话联系",
        work_time: "周一至周五: 8:30-12:00 14:00-18:00 (北京时间)",
        by_email: "邮箱联系",
        by_wechat: "微信公众号",
        by_wechat_describe: "点击复制,前往微信关注“飞宇”公众号,联系客服",
        submit: "提交",
        camera_name_placeholder: "请输入您的相机型号",
        lens_name_placeholder: "请输入您的镜头型号",
        notice: "注意",
        close: "关闭",
        please_enter_the_camera_model: "请输入相机型号",
        please_enter_feedback_information: "请输入反馈信息",
        please_enter_contact_information: "请输入联系方式",
        thanks_for_your_feedback: "感谢您的反馈。",
        intent_error_please_try_again: "网络错误,请重试。",
        wechat_copyed: "已经复制公众号到剪贴板,将会跳转微信。",
        online_customer_service: "在线客服",
        online_customer_service_describe: "点击前往在线客服窗口"
    },

    Deviceinfo: {
        Search_Camera: "搜索相机",
        Select_Your__Camera_Brand: "请选择您的相机品牌",
        Select_Your_Camera_model: "请选择您的相机型号",
        Select_Your_Camera_Lens:"请选择您的镜头型号",
        No_Search_Result:"暂无搜索结果",
        No_Search_Result_Sub:"没有找到我的相机型号？",
        No_Data_Recored:"没有收录数据",
        Device_Info_Title:"兼容性信息",

        Aperture_Adjustment:"光圈调节",
        ISO_Adjustment:"感光度调节",
        Halfway_Press_To_Focus:"半按快门对焦",
        Electronic_Follow_Focus:"电子跟焦",
        Electronic_Zoom:"电子变焦",
        Camera_Firmware_Version:"相机固件版本",
        Gimbal_Firmware_Version:"Gimbal固件版本",
        BlueTooth_Firmware_Version:"蓝牙固件版本",
        Note:"备注:",
        Short_End_Horizontally:"横拍短焦",
        Long_End_Horizontally:"横拍长焦",
        Short_End_Vertically:"竖拍短焦",
        Long_End_Vertically:"竖拍长焦",
        Need_Select_Lens:"请选择对应镜头",
        Camera_Mounting_Method: "相机搭载方式",

        Control_features_cable: "线控功能",
        Controllability: "可控",
        Capture_photo: "拍照",
        Record_video: "录像",
        Playback: "查看图库",
        Shutter_speed: "快门调节",
        ISO: "ISO",
        Bluetooth: "蓝牙",
        shutter: "快门",
        Control_features_bluetooth: "蓝牙控制功能",
        Camera_brand: "品牌名称",
        Camera_model: "相机型号",
        Lens: "镜头型号",
        Balance: "调平",
        Control_cable: "控制线",
        Bluetooth_shutter: "蓝牙快门",
    },
    RegisterNewUserPrompt:{
        UsageTips:"使用小贴士：",
        ParameterIntroduction:"参数介绍：",
    },
    AutoRotate:{
        UsageTips_1: "1、点击开始旋转，再次点击取消旋转时云台会旋转到初始位置才停下",
        UsageTips_2: "2、退出：点击退出，云台恢复横拍状态",
    },
    ShootPanoramic:{
        ShootPanoramicUsageTips:" 拍摄过程中请勿操作或移动云台",
    },
    TimeLapseShoot:{
        UsageTips:" 拍摄过程中请勿操作摇杆",
        Parameter_1:"间隔：配置单帧拍摄时间间隔",
        Parameter_2:"帧率：配置成片视频帧率",
        Parameter_3:"时间：配置拍摄过程总时长",
        Parameter_4:"成片时间和张数由配置计算而来",
        Stilltimelapse:"静态延时效果",
        Motionlapse:"轨迹延时效果",
        Hyperlapse:"移动延时效果",
    },
    TrackVideo:{
        UsageTips_1: "1、+新增轨迹点",
        UsageTips_2: "2、-删除选中的轨迹点",
        UsageTips_3: "3、单击选中轨迹点，云台快速运动到点位，再次单击可进行点位参数修改",
    }
}

export const language_en = {

    Feedback: {
        main_title: "Please complete your feedback information",
        sub_title: "we will do better",
        boarding: "Actual test whether it can be carried",
        yes: "yes",
        no: "no",
        no_test: "Not tested",
        camera_name: "Camera model",
        lens_name: "Lens model",
        feedback: "problem description or suggestion",
        feedback_describe: "Detailing your operation steps and phenomena will help us quickly solve the problem.",
        contact: "Contact information",
        phone_or_email: "Mobile phone number/email",
        feekback_way: "You can also give feedback in the following ways",
        by_phone: "Phone",
        work_time: "Monday to Friday: 8:30-12:00 14:00-18:00 (Beijing time)",
        by_email: "Email",
        by_wechat: "Wechat",
        by_wechat_describe: "Click to copy, go to WeChat to follow the 'Feiyu' public account, and contact customer service.",
        submit: "submit",
        camera_name_placeholder: "your camera model.",
        lens_name_placeholder: "your lens model.",
        notice: "Notice",
        close: "Close",
        please_enter_the_camera_model: "Please enter your camera model.",
        please_enter_feedback_information: "Please enter feedback information.",
        please_enter_contact_information: "Please enter contact information.",
        thanks_for_your_feedback: "Thanks for your feedback.",
        intent_error_please_try_again: "Internet error, please try again.",
        wechat_copyed: "The word has been copied to the clipboard, and it will jump to WeChat.",
        online_customer_service: "Online customer service",
        online_customer_service_describe: "Click to go to the online customer service window."

    },
    Deviceinfo: {


        Search_Camera: "Search camera",
        Select_Your__Camera_Brand: "select your camera`s brand",
        Select_Your_Camera_model: "select your camera`s model",
        Select_Your_Camera_Lens:"select your camera`s lens",
        No_Search_Result:"no search result",
        No_Search_Result_Sub:"no found your camera?",
        No_Data_Recored:"no data recored",
        Device_Info_Title:"device compatibility information",

        Aperture_Adjustment:"Aperture adjustment",
        ISO_Adjustment:"ISO adjustment",
        Halfway_Press_To_Focus:"Halfway press focus",
        Electronic_Follow_Focus:"Pull focus",
        Electronic_Zoom:"Digital zoom control",
        Camera_Firmware_Version:"Camera firmware version",
        Gimbal_Firmware_Version:"Gimbal firmware version",
        BlueTooth_Firmware_Version:"BlueTooth firmware version",
        Note:"Note:",

        Short_End_Horizontally:"Short end (horizontally)",
        Long_End_Horizontally:"Long end (horizontally)",
        Short_End_Vertically:"Short end (vertically)",
        Long_End_Vertically:"Long end (vertically)",
        Need_Select_Lens:"Need select lens",
        Camera_Mounting_Method: "Installation",

        Control_features_cable: "Control (cable)",
        Controllability: "Controllability",
        Capture_photo: "Capture photo",
        Record_video: "Record video",
        Playback: "Playback",
        Shutter_speed: "Shutter speed",
        ISO: "ISO",
        Bluetooth: "Bluetooth",
        shutter: "Shutter",
        Control_features_bluetooth: "Control features",
        Camera_brand: "Camera brand",
        Camera_model: "Camera_model",
        Lens: "Lens",
        Balance: "Blance",
        Control_cable: "Control cable",
        Bluetooth_shutter: "Bluetooth shutter",
    },
    RegisterNewUserPrompt:{
        UsageTips:"Usage Tips:",
        ParameterIntroduction:"Parameter Introduction:",
    },
    AutoRotate:{
        UsageTips_1: "1. Tap to start rotation, and click again to cancel rotation. The gimbal will rotate to the initial position before stopping.",
        UsageTips_2: "2. Exit: Tap exit, and the gimbal returns to the landscape shooting state.",
    },
    ShootPanoramic:{
        ShootPanoramicUsageTips:" Do not operate or move the gimbal during the shooting process.",
    },
    TimeLapseShoot:{
        UsageTips:" Do not operate the joystick during the shooting process.",
        Parameter_1:"Interval: Configure the time interval for single-frame shooting.",
        Parameter_2:"FPS: Configure the frame rate for continuous video shooting.",
        Parameter_3:"Time: Configure the total duration of the shooting process.",
        Parameter_4:"The clip length and number of photos are calculated based on the configuration.",
        Stilltimelapse:"Static TimeLapse Effect",
        Motionlapse:"Motionlapse Effect",
        Hyperlapse:"Hyperlapse Effect",
    },
    TrackVideo:{
        UsageTips_1: "1. + Add a new waypoint.",
        UsageTips_2: "2. - Delete the selected waypoint.",
        UsageTips_3: "3. Tap to select a waypoint, and the gimbal will quickly move to the point. Tap again to modify the point parameters.",
    }
}

